import { User } from '../models';

export const getBirthday = (birthday?: string): string => {
  if (!birthday) {
    return 'N/A';
  }

  let birthDate = new Date(birthday);

  const day = birthDate.getDate();
  const month = birthDate.getMonth() + 1;
  const year = birthDate.getFullYear();
  const formattedDate = `${day.toString().padStart(2, '0')}.${month
    .toString()
    .padStart(2, '0')}.${year}`;

  return formattedDate;
};

export const getAge = (birthday?: string): number => {
  if (!birthday) {
    return 0;
  }

  let birthDate = new Date(birthday);

  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
};

export const getCurrentWeight = (user: User): number => user.coreData?.weightSixMonthsAgoInKg || 0;

export const getStartWeight = (user: User): number => user.coreData?.initialWeightInKg || 0;

export const getBMI = (bodySizeInCm?: number, weight?: number): number => {
  if (!bodySizeInCm || !weight) {
    return 0;
  }

  const heightInM = bodySizeInCm / 100;
  return Math.floor(weight / (heightInM * heightInM)); 
};

export const getBMIScore = (bmi: number): number => {
  if (bmi <= 18.5) return 2;
  if (bmi < 20.0) return 1;
  return 0; 
};

export const getWeightChange = (currentWeight?: number, previousWeight?: number): number => {
  if (!currentWeight || !previousWeight || previousWeight === 0) {
    return 0;
  }

  return Math.floor(100 - (previousWeight / currentWeight) * 100);
};

export const getWeightChangeScore = (weightChange: number): number => {
  if (weightChange < -0.1) return 2;
  if (weightChange < -0.05) return 1;
  return 0; 
};

export const getSurveyScore = (questionIndex: number, answer: number | string): number => {
  if (questionIndex === 0 || questionIndex === 1) {
    if (Number(answer) < 4) return 0;
    if (Number(answer) >= 4 && Number(answer) <= 6) return 1;
    return 2;
  }
  if (questionIndex === 2) {
    if (Number(answer) === 100) return 0;
    if (Number(answer) >= 50 && Number(answer) <= 99) return 1;
    return 2;
  }
  return 0;
};

